$(document).ready(function() {
  $(".product-accordion-list .accordion-item").click(function() {
    $(this).toggleClass("active");
    $(this).find(".toggle_content").slideToggle();
  });

  // remove the material ausklappen button from nature-skin pages
  if (window.location.href.includes("nature-skins")) {
    $(".all-material-toggle").css({
      display: "none",
    });
  }

  if($(".product-image-slider .image-slider .slider-item").length) {
    $(".product-image-slider .image-slider").slick({
      dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  $(".ticker-bar.ticker-1").eocjsNewsticker({
    divider: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
    speed: 10,
    timeout: 0.5
  });

  $(".ticker-bar.ticker-2").eocjsNewsticker({
    divider: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
    speed: 10,
    timeout: 0.5
  }); 

  $(".all-material-toggle").click(function(e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(".swatch-items").parent().slideToggle();
    $(".materials").slideToggle();
    if($(this).hasClass('active')) {
      $(this).find(".btn-label").html("Materialien ausblenden");
    } else {
      $(this).find(".btn-label").html("Alle Materialien zeigen");
    }
  });

  $(".icon-button").click(function() {
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#shopify-section-product-image-text .featured-link--section:last-child").offset().top - 70
    }, 200);
  });

  $(window).scroll(positionButton);
  $(window).resize(positionButton);

  function positionButton() {
    if($(window).width() > 798) {
      return;
    }
    $(".mobile-add_to_cart").css({
      position: "unset"
    });
    var scrollTop = $(window).scrollTop();
    var offsetTop = $(".mobile-add_to_cart").offset().top

    if(offsetTop < scrollTop + 50) {
      $(".mobile-add_to_cart").css({
        position: "fixed",
        top: "39px",
      });

      $(".mobile-add_to_cart").css({
        background: "#3a3a3a"
      });

      $(".mobile-add_to_cart button").addClass("button_fixed");

      let spacer = document.createElement("div");
      spacer.id = "crosssell_button_spacer";
      spacer.style.height = "200px";
      spacer.style.backgroundColor = "red";

      $(".mobile-btn-design").css({
        marginBottom: "110px"
      });

    } else {
      $(".mobile-add_to_cart").css({
        position: "unset",
        top: "0",
      });
      $(".mobile-add_to_cart").css({
        background: "#000"
      });
      $(".mobile-add_to_cart button").removeClass("button_fixed");

      $(".mobile-btn-design").css({
        marginBottom: "0px"
      });
    }
  }

  $(".materials .swatch-element").click(function(e) {
    $(".materials .swatch-element").removeClass("active");
    $(this).addClass("active");

    if ($(this).hasClass('soldout')) {
      $('.notify_form_api').show()
      $('.crosssell-submit').hide()
    } else {
      $('.notify_form_api').hide()
      $('.crosssell-submit').show()
    }
  });

  var el = $('.swatch_options input[type="radio"]:checked')
  if ($(el).data('stock') == false ) {
    $('.notify_form_api').show()
    $('.mobile-add_to_cart .crosssell-submit').hide()
  } else {
    $('.notify_form_api').hide()
    $('.mobile-add_to_cart .crosssell-submit').show()
  }

  $(".swatch-items .swatch-element").click(function() {
    $(".materials .swatch-element").removeClass("active");
    $(".materials div[data-value='" + $(this).attr("data-value") + "']").addClass("active");
    if ($(this).hasClass('soldout')) {
      $('.notify_form_api').show()
      $('.mobile-add_to_cart .crosssell-submit').hide()
    } else {
      $('.notify_form_api').hide()
      $('.mobile-add_to_cart .crosssell-submit').show()
    }
  });
  $(".product_gallery").flickity({
    pageDots: true,
  });
});